import {DiagnosticReportId} from '@legit-health/ui';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';

export const DIAGNOSTIC_REPORT_OUTDATED = 'diagnosticReport.outdated';

export interface DiagnosticReportOutdatedEvent extends DomainEvent {
  diagnosticReportId: DiagnosticReportId;
}

export function createDiagnosticReportOutdatedEvent(
  diagnosticReportId: DiagnosticReportId
): DiagnosticReportOutdatedEvent {
  return Object.freeze({
    name: DIAGNOSTIC_REPORT_OUTDATED,
    diagnosticReportId
  });
}
